// Creator-Profile — Route `/@:handle` (Phase 11 Step 4 Block 3).
//
// Die Route-Funktion (`+route.ts`) liefert `routeParams.handle` ohne das
// literale `@` — direkt Lookup-fähig. Unbekannte Handles rendern die
// geteilte `NotFound`-Komponente (Phase 11 Step 5 Block 0 — strict 404).

import { AppShell } from "../../src/components/layout/AppShell";
import { CreatorProfile } from "../../src/components/creator/CreatorProfile";
import { NotFound } from "../../src/components/common/NotFound";
import { PINK } from "../../src/lib/tokens";
import { usePageContext } from "../../src/hooks/usePageContext";
import { CREATORS_BY_HANDLE } from "../../src/lib/mock/creators";

export default function Page() {
  const { routeParams } = usePageContext();
  const handle = routeParams?.handle ?? "";
  const creator = CREATORS_BY_HANDLE[handle];

  if (!creator) {
    return (
      <NotFound
        eyebrow="Creator nicht gefunden"
        headline={
          <>
            Kein Creator mit dem Handle{" "}
            <em style={{ color: PINK, fontStyle: "italic" }}>@{handle}</em>.
          </>
        }
        detail="Der Handle ist abgelaufen oder nie da gewesen."
      />
    );
  }

  return (
    <AppShell currentNavId="" loggedIn={false}>
      <CreatorProfile creator={creator} />
    </AppShell>
  );
}
